import React from 'react'
import { Form, Button } from 'react-bootstrap'

export const BulkUploadStdPricingView = (props) => {


  //used for changing shipping prices
  return (
    <div>
    <Form onSubmit={props.onSubmit}>
      <Form.Group className="mb-3">
        <Form.Control as="textarea" placeholder="Paste bulk pricing model data" name="bulkPricingModelData" />
      </Form.Group>


      <Form.Text id="dataInput" muted>
        <div>Download example file here. Keep the headers in the paste</div>
        <div>View a list of permissible country codes here</div>
      </Form.Text>
      <Button disabled={props.password === '4207' ? false : true} type="submit">Submit</Button>
    </Form>
    <div>Enter PIN to access: </div><input onChange={(e) => {props.setPassword(e.target.value)}}></input>
    </div>
  )
}